import ESTIMATE_CONSTANT from "../../constant/estimateConstant"
import estimateField from "../../service/estimateFields/estimateField"
import filterEnableValues from "../../service/filterEnableValues"
import { isFlexible, isMetal } from "../../service/oneClickIs"
import type { EstimateParams } from "../../types/params"
import type EstimateValues from "../../types/params"

/**
 * convertForServerをEstimateParams向けにラップする
 *
 * 【注意事項】
 * - EstimateMeta、optionsは含めない
 * - bomSnapshotIdについては、バックエンドでセッション情報として部品リストを持ち回るため、URLに含めてもセッション破棄後は無効になるため含めない。
 * @param params
 */
export const convertForServerByParams = (params: EstimateParams) => {
  return {
    ...convertForServer(params.values),
    localStorageMapkey: params.procurementValues.localStorageMapkey,
    deliveryZeroFlg: params.deliveryZeroFlg,
    mountQuickFlg: params.mountQuickFlg,
  }
}

// サーバーとフロントでのプロパティ名や値の違いを吸収します。
// 名前の違い
// ・材質（メタル材質）
// ・板厚（ベース材厚）
//
// 値の違い
// ・表面処理
export const convertForServer = (values: EstimateValues) => {
  const filtered = filterEnableValues(values)

  let { surfaceFinishing } = filtered
  if (filtered.hardGoldOnPCIEdgeTerminal === ESTIMATE_CONSTANT.端子部のみ電解金めっき.する.value) {
    switch (surfaceFinishing) {
      case ESTIMATE_CONSTANT.表面処理["水溶性フラックス(リジッド)"].value:
        surfaceFinishing = ESTIMATE_CONSTANT.表面処理["端子部のみ電解金めっき＋水溶性フラックス"].value
        break
      case ESTIMATE_CONSTANT.表面処理["有鉛はんだレベラー(リジッド)"].value:
        surfaceFinishing = ESTIMATE_CONSTANT.表面処理["端子部のみ電解金めっき＋有鉛はんだレベラー"].value
        break
      case ESTIMATE_CONSTANT.表面処理["無鉛はんだレベラー(リジッド)"].value:
        surfaceFinishing = ESTIMATE_CONSTANT.表面処理["端子部のみ電解金めっき＋無鉛はんだレベラー"].value
        break
    }
  }

  const obj = {
    ...filtered,
    board: isMetal(values) ? filtered.metalBoard : filtered.board,
    boardThickness: isFlexible(values) ? filtered.fpcBoardThickness : filtered.boardThickness,
    surfaceFinishing,
    externalsSilk: filtered.externalsSilk || null,
    controlWiring: filtered.controlWiring || null,
    circuit: filtered.circuit || null,
    planBgacsp: filtered.planBgacsp || null,
    otherSilk: filtered.otherSilk || null,
    designInstruction: filtered.designInstruction || null,
  }

  delete (obj as any).metalBoard
  delete (obj as any).fpcBoardThickness
  delete (obj as any).hardGoldOnPCIEdgeTerminal

  return obj
}

export const convertForClient = (queryString: string) => {
  const params = new URLSearchParams(queryString)

  // NOTE: 過去に発行されたURLのための変換処理です。
  const parts = params.get(estimateField.partsProcurementCourse.key)
  switch (parts) {
    case ESTIMATE_CONSTANT.部品調達.あり.value:
      params.delete(estimateField.partsProcurementCourse.key)
      params.append(estimateField.partsProcurementCourse.key, "true")
      break
    case ESTIMATE_CONSTANT.部品調達.なし.value:
      params.delete(estimateField.partsProcurementCourse.key)
      params.append(estimateField.partsProcurementCourse.key, "false")
      break
  }

  const kibanType = params.get(estimateField.kibanType.key)
  const board = params.get(estimateField.board.key)
  if (board && kibanType === ESTIMATE_CONSTANT.基板の種類.メタル放熱基板.value) {
    params.delete(estimateField.board.key)
    params.append(estimateField.metalBoard.key, board)
  }
  const boardThickness = params.get(estimateField.boardThickness.key)
  if (boardThickness && kibanType === ESTIMATE_CONSTANT.基板の種類.フレキシブル基板.value) {
    params.delete(estimateField.boardThickness.key)
    params.append(estimateField.fpcBoardThickness.key, boardThickness)
  }

  const surfaceFinishing = params.get(estimateField.surfaceFinishing.key)
  switch (surfaceFinishing) {
    case ESTIMATE_CONSTANT.表面処理["端子部のみ電解金めっき＋水溶性フラックス"].value:
      params.delete(estimateField.surfaceFinishing.key)
      params.append(estimateField.surfaceFinishing.key, ESTIMATE_CONSTANT.表面処理["水溶性フラックス(リジッド)"].value)
      params.append(estimateField.hardGoldOnPCIEdgeTerminal.key, ESTIMATE_CONSTANT.端子部のみ電解金めっき.する.value)
      break
    case ESTIMATE_CONSTANT.表面処理["端子部のみ電解金めっき＋有鉛はんだレベラー"].value:
      params.delete(estimateField.surfaceFinishing.key)
      params.append(
        estimateField.surfaceFinishing.key,
        ESTIMATE_CONSTANT.表面処理["有鉛はんだレベラー(リジッド)"].value,
      )
      params.append(estimateField.hardGoldOnPCIEdgeTerminal.key, ESTIMATE_CONSTANT.端子部のみ電解金めっき.する.value)
      break
    case ESTIMATE_CONSTANT.表面処理["端子部のみ電解金めっき＋無鉛はんだレベラー"].value:
      params.delete(estimateField.surfaceFinishing.key)
      params.append(
        estimateField.surfaceFinishing.key,
        ESTIMATE_CONSTANT.表面処理["無鉛はんだレベラー(リジッド)"].value,
      )
      params.append(estimateField.hardGoldOnPCIEdgeTerminal.key, ESTIMATE_CONSTANT.端子部のみ電解金めっき.する.value)
      break
  }

  return params
}
